import {graffitiConstants} from './graffiti.constants';
import {authenticationConstants} from "../authentication/auth.constants";

const initialState = {
    communes: null,
    quartiers: null,
    rues: null,
    metadata: null,
    loading: false,
    error: null,
    // caches for features
    communeFeaturesById: {},
    quartierFeaturesById: {},
    rueFeaturesById: {},
    communeFeatureLoadingById: {},
    quartierFeatureLoadingById: {},
    rueFeatureLoadingById: {},
    communeFeatureErrorById: {},
    quartierFeatureErrorById: {},
    rueFeatureErrorById: {},
}

export function graffiti(state = initialState, action) {
    switch (action.type) {
        // Loading states
        case graffitiConstants.GRAFFITI_COMMUNES_FETCH_REQUEST:
        case graffitiConstants.GRAFFITI_QUARTIERS_FETCH_REQUEST:
        case graffitiConstants.GRAFFITI_RUES_FETCH_REQUEST:
        case graffitiConstants.GRAFFITI_METADATA_FETCH_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case graffitiConstants.GRAFFITI_COMMUNE_FEATURE_FETCH_REQUEST:
            return {
                ...state,
                communeFeatureLoadingById: { ...state.communeFeatureLoadingById, [action.id]: true },
                communeFeatureErrorById: { ...state.communeFeatureErrorById, [action.id]: null }
            };
        case graffitiConstants.GRAFFITI_QUARTIER_FEATURE_FETCH_REQUEST:
            return {
                ...state,
                quartierFeatureLoadingById: { ...state.quartierFeatureLoadingById, [action.id]: true },
                quartierFeatureErrorById: { ...state.quartierFeatureErrorById, [action.id]: null }
            };
        case graffitiConstants.GRAFFITI_RUE_FEATURE_FETCH_REQUEST:
            return {
                ...state,
                rueFeatureLoadingById: { ...state.rueFeatureLoadingById, [action.id]: true },
                rueFeatureErrorById: { ...state.rueFeatureErrorById, [action.id]: null }
            };

        // Success states
        case graffitiConstants.GRAFFITI_COMMUNES_FETCH_SUCCESS:
            return {
                ...state,
                communes: action.communes,
                loading: false,
                error: null
            };
        case graffitiConstants.GRAFFITI_QUARTIERS_FETCH_SUCCESS:
            return {
                ...state,
                quartiers: action.quartiers,
                loading: false,
                error: null
            };
        case graffitiConstants.GRAFFITI_RUES_FETCH_SUCCESS:
            return {
                ...state,
                rues: action.rues,
                loading: false,
                error: null
            };
        case graffitiConstants.GRAFFITI_METADATA_FETCH_SUCCESS:
            return {
                ...state,
                metadata: action.metadata,
                loading: false,
                error: null
            };

        // Failure states
        case graffitiConstants.GRAFFITI_COMMUNES_FETCH_FAILURE:
        case graffitiConstants.GRAFFITI_QUARTIERS_FETCH_FAILURE:
        case graffitiConstants.GRAFFITI_RUES_FETCH_FAILURE:
        case graffitiConstants.GRAFFITI_METADATA_FETCH_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };
        case graffitiConstants.GRAFFITI_COMMUNE_FEATURE_FETCH_SUCCESS:
            return {
                ...state,
                communeFeaturesById: { ...state.communeFeaturesById, [action.id]: action.feature },
                communeFeatureLoadingById: { ...state.communeFeatureLoadingById, [action.id]: false },
                communeFeatureErrorById: { ...state.communeFeatureErrorById, [action.id]: null },
            };
        case graffitiConstants.GRAFFITI_QUARTIER_FEATURE_FETCH_SUCCESS:
            return {
                ...state,
                quartierFeaturesById: { ...state.quartierFeaturesById, [action.id]: action.feature },
                quartierFeatureLoadingById: { ...state.quartierFeatureLoadingById, [action.id]: false },
                quartierFeatureErrorById: { ...state.quartierFeatureErrorById, [action.id]: null },
            };
        case graffitiConstants.GRAFFITI_RUE_FEATURE_FETCH_SUCCESS:
            return {
                ...state,
                rueFeaturesById: { ...state.rueFeaturesById, [action.id]: action.feature },
                rueFeatureLoadingById: { ...state.rueFeatureLoadingById, [action.id]: false },
                rueFeatureErrorById: { ...state.rueFeatureErrorById, [action.id]: null },
            };
        case graffitiConstants.GRAFFITI_COMMUNE_FEATURE_FETCH_FAILURE:
            return {
                ...state,
                communeFeatureLoadingById: { ...state.communeFeatureLoadingById, [action.id]: false },
                communeFeatureErrorById: { ...state.communeFeatureErrorById, [action.id]: action.error },
            };
        case graffitiConstants.GRAFFITI_QUARTIER_FEATURE_FETCH_FAILURE:
            return {
                ...state,
                quartierFeatureLoadingById: { ...state.quartierFeatureLoadingById, [action.id]: false },
                quartierFeatureErrorById: { ...state.quartierFeatureErrorById, [action.id]: action.error },
            };
        case graffitiConstants.GRAFFITI_RUE_FEATURE_FETCH_FAILURE:
            return {
                ...state,
                rueFeatureLoadingById: { ...state.rueFeatureLoadingById, [action.id]: false },
                rueFeatureErrorById: { ...state.rueFeatureErrorById, [action.id]: action.error },
            };

        // Clear data
        case graffitiConstants.GRAFFITI_CLEAR_REQUEST:
            return {
                ...state,
                communes: null,
                quartiers: null,
                rues: null,
                metadata: null,
                error: null,
                communeFeaturesById: {},
                quartierFeaturesById: {},
                rueFeaturesById: {},
                communeFeatureLoadingById: {},
                quartierFeatureLoadingById: {},
                rueFeatureLoadingById: {},
                communeFeatureErrorById: {},
                quartierFeatureErrorById: {},
                rueFeatureErrorById: {},
            };

        // Logout
        case authenticationConstants.LOGOUT:
            return {
                initialState
            }

        default:
            return state
    }
}